import { useLocation, useNavigationType, useOutlet } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

const slideVariants = {
  initial: { opacity: 0, left: 40 },
  animate: { opacity: 1, left: 0 },
  exit: { opacity: 0, left: -40 },
};

const slideTransition = {
  duration: 0.2,
  ease: "easeInOut",
} as const;

export function AnimatedOutlet() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const outlet = useOutlet();

  // 뒤로가기(POP) 시 애니메이션 스킵
  if (navigationType === "POP") {
    return <div key={location.pathname}>{outlet}</div>;
  }

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        style={{ position: "relative" }}
        variants={slideVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={slideTransition}
      >
        {outlet}
      </motion.div>
    </AnimatePresence>
  );
}
